import MuiButton from '@mui/material/Button';
import { styled } from '@mui/material/styles';

interface ButtonProps {
  variant?: string;
  height?: string;
  shadow?: boolean;
}

export const Button = styled(MuiButton)<ButtonProps>`
  background: ${({ theme, variant }) =>
    theme.buttonTheme[variant]?.background}; // Amarelo sólido original
  color: ${({ theme, variant }) => theme.buttonTheme[variant]?.color};
  border: ${({ theme, variant }) => theme.buttonTheme[variant]?.border};
  border-radius: 36px;
  padding: 8px 24px;
  text-transform: uppercase;
  overflow: hidden;
  position: relative;
  transition: all 0.8s ease-in-out;
  height: ${(props) => (props.height ? props.height : '')};

  // Glassmorphism (leve) + Neomorphism
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  box-shadow: ${(props) =>
    props.shadow
      ? '6px 6px 12px rgba(0, 0, 0, 0.15), -4px -4px 12px rgba(255, 255, 255, 0.25)'
      : ''};

  span {
    position: relative;
    z-index: 2;
    color: inherit;
    transition: color 0.4s ease-in-out;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -160px;
    width: 150px;
    height: 100%;
    background: ${(props) => props.theme.buttonTheme.secondary.color};
    transform: skew(-30deg);
    opacity: 0.2;
    z-index: 1;
    transition: transform 0.8s ease-in-out;
  }

  &:hover::before {
    transform: skew(-30deg) translateX(400%);
  }

  &:hover {
    background: ${({ theme, variant }) => theme.buttonTheme[variant]?.color};

    color: ${({ theme, variant }) => theme.buttonTheme[variant]?.hover};
    border: 1px solid
      ${({ theme, variant }) => theme.buttonTheme[variant]?.backgroundColor};
    box-shadow:
      4px 4px 16px rgba(0, 122, 255, 0.25),
      -2px -2px 8px rgba(255, 255, 255, 0.4);
  }

  &:hover span {
    color: ${({ theme, variant }) => theme.buttonTheme[variant]?.hover};
  }

  @container (max-width: 700px) {
    padding: 8px; /* reduz espaço lateral */
    font-size: 0px;
  }
`;
